// extracted by mini-css-extract-plugin
module.exports = {"nameContainer":"FileChip_nameContainer__14t_r","name":"FileChip_name__3CX_P","fileChipsContainer":"FileChip_fileChipsContainer__26dnO","button":"FileChip_button__1Dy8c"};